import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, setupAdmin, setupStatus } from "@/lib/auth";
import { Lock, User } from "lucide-react";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [setupToken, setSetupToken] = useState("");
  const [setupRequired, setSetupRequired] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setupStatus().then((result) => {
      if (result.ok) {
        setSetupRequired(result.setupRequired);
      }
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = setupRequired
        ? await setupAdmin({ setupToken, username, password })
        : await login(username, password);

      if (result.ok) {
        if (setupRequired) {
          setSetupRequired(false);
          setPassword("");
          setSetupToken("");
          setError("Conta criada. Entre com o utilizador e senha definidos.");
        } else {
          navigate(result.mustChangePassword ? "/admin/change-password" : "/admin");
        }
      } else {
        setError(
          result.reason === "network_error"
            ? "API indisponivel. Confirme se o backend esta ativo."
            : result.detail || "Utilizador ou senha incorretos"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f5ee] flex items-center justify-center p-5">
      <div className="w-full max-w-md">
        <div className="mb-12 text-center">
          <div className="font-display text-4xl text-[#0a0a0a] mb-2">
            BEZIER<span className="text-[#ff6b35]">CLICK</span>
          </div>
          <p className="font-mono text-xs uppercase tracking-widest text-[#0a0a0a]/70">
            {setupRequired ? "Criar primeiro administrador" : "Painel de Administracao"}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white p-8 border-4 border-[#0a0a0a]">
          {setupRequired && (
            <div className="mb-6">
              <label className="block font-mono text-xs uppercase tracking-widest text-[#0a0a0a] mb-3">
                * Token de instalacao
              </label>
              <input
                type="password"
                value={setupToken}
                onChange={(e) => setSetupToken(e.target.value)}
                placeholder="Token unico"
                className="w-full brutal-input text-sm"
                disabled={loading}
              />
            </div>
          )}

          <div className="mb-6">
            <label className="block font-mono text-xs uppercase tracking-widest text-[#0a0a0a] mb-3">
              * Utilizador
            </label>
            <div className="flex items-center gap-2 border-3 border-[#0a0a0a] bg-[#f8f5ee]">
              <User size={18} className="text-[#ff6b35] ml-3" />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                className="flex-1 bg-transparent p-3 outline-none font-mono text-sm"
                disabled={loading}
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="block font-mono text-xs uppercase tracking-widest text-[#0a0a0a] mb-3">
              * Senha
            </label>
            <div className="flex items-center gap-2 border-3 border-[#0a0a0a] bg-[#f8f5ee]">
              <Lock size={18} className="text-[#ff6b35] ml-3" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                className="flex-1 bg-transparent p-3 outline-none font-mono text-sm"
                disabled={loading}
              />
            </div>
          </div>

          {error && (
            <div className="mb-6 p-3 bg-red-100 border-2 border-red-500 text-red-700 font-mono text-xs uppercase">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full btn-brutal btn-brutal-orange font-display uppercase text-base py-3 disabled:opacity-50"
          >
            {loading ? "Aguarde..." : setupRequired ? "Criar Admin" : "Entrar"}
          </button>

          <p className="mt-8 text-center font-mono text-xs uppercase tracking-widest text-[#0a0a0a]/60">
            Acesso restrito
          </p>
        </form>

        <a
          href="/"
          className="block text-center mt-8 font-display text-sm text-[#0a0a0a] hover:text-[#ff6b35] transition-colors underline decoration-2 underline-offset-2"
        >
          &larr; Voltar ao site
        </a>
      </div>
    </div>
  );
};

export default AdminLogin;
